import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["panel", "backdrop", "content", "title"]

  connect() {
    this.handleEscape = this.handleEscape.bind(this)
  }

  disconnect() {
    document.removeEventListener("keydown", this.handleEscape)
    document.body.classList.remove("overflow-hidden")
  }

  open(event) {
    event?.preventDefault()

    // Load content via Turbo Frame if URL provided
    const url = event?.currentTarget?.dataset?.slideoutUrl
    if (url && this.hasContentTarget) {
      this.contentTarget.src = url
    }

    // Update title if provided
    const title = event?.currentTarget?.dataset?.slideoutTitle
    if (title && this.hasTitleTarget) {
      this.titleTarget.textContent = title
    }

    document.body.classList.add("overflow-hidden")
    document.addEventListener("keydown", this.handleEscape)

    this.backdropTarget.classList.remove("hidden")
    this.panelTarget.classList.remove("translate-x-full")

    // Double rAF ensures browser has painted the element before transitioning
    requestAnimationFrame(() => {
      requestAnimationFrame(() => {
        this.backdropTarget.classList.remove("opacity-0")
      })
    })
  }

  close() {
    document.body.classList.remove("overflow-hidden")
    document.removeEventListener("keydown", this.handleEscape)

    this.panelTarget.classList.add("translate-x-full")
    this.backdropTarget.classList.add("opacity-0")

    setTimeout(() => {
      this.backdropTarget.classList.add("hidden")
      // Clear content after closing
      if (this.hasContentTarget) {
        this.contentTarget.innerHTML = ""
      }
    }, 300)
  }

  handleEscape(event) {
    if (event.key === "Escape") this.close()
  }

  // Called after successful form submission via Turbo
  success(event) {
    // Only close on successful response (2xx status)
    if (event.detail?.success) {
      this.close()
      // Reload the page to show updated data
      window.location.reload()
    }
  }
}
